export default "__VITE_ASSET__BdTRUwKq__"